import { withFormsy } from 'formsy-react';
import _ from 'lodash'
import Datetime from 'react-datetime';
import moment from 'moment-timezone'
import { zones } from 'moment-timezone/data/meta/latest.json';

import React from 'react';

class DateTimeInput extends React.Component {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);

    this.state = {
      selectedDate: new Date()
    }
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {

    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const showRequired = this.props.showRequired();

    const {
      showErrors = false,
      icon = null,
      label = null,
      required = false,
      name,
    } = this.props;

    const hasError = showErrors && errorMessage;

    return (
      <div className={"pt-form-group"}>
        {label && (
          <label className="pt-label" htmlFor={name}>
            {label + " "}
            {required && (
              <span className="f5 pt-text-muted">(required)</span>
            )}
          </label>
        )}
        <div className={"pt-form-content" + (hasError ? " pt-intent-danger" : "")}>
          <div className={"pt-input-group"}>
            {icon && (
              <span className={"pt-icon pt-icon-" + icon}></span>
            )}
            <Datetime value={this.props.getValue() ? moment(this.props.getValue()) : moment()}
                      onChange={(momentDate) => this.onChange(momentDate)} />
          </div>
          <div className="pt-form-helper-text">
            <div className="inline-error">
              {(showErrors && errorMessage) ? (errorMessage) :
               (showErrors && showRequired) ? "Field is required." : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }

  onChange(momentDate) {
    this.props.setValue(momentDate.valueOf());
  }
}

export default withFormsy(DateTimeInput);


// WEBPACK FOOTER //
// ./src/components/form/DateTimeInput.js